import React, { Component } from 'react';


import { observable, computed } from 'mobx';
import { observer, inject } from 'mobx-react'
@inject("store")
@observer
class GeneralDetails extends Component {

	@observable error = false
	@observable errorText = "Please fill the name"

	componentDidMount() {
		this.props.store.step = 4
	}

	@computed get completed() {
		const { doctor } = this.props.store

		if (!(doctor.children)) { return false  }
		if (!(doctor.wc)) { return false  }
		if (!(doctor.dva)) { return false  }
		if (!(doctor.mvit)) { return false  }
		
		return true
	}

	handleNext = () => {
		if (!this.completed) { this.error = true;return  }
		this.props.store.nextStep()
		this.props.history.push(`/listing/new/${this.props.store.step + 2}`)
	}

	handlePrev = () => {
		this.props.store.prevStep()
		this.props.history.push(`/listing/new/${this.props.store.step}`)
	}

	render() {
		const { doctor } = this.props.store
		return (
			<div>

				<h2 >5. Patients Details</h2>

				
					<h4 className={`${this.error && 'error'} ${this.error && doctor.children && 'complete'}`} >
						Do you see children?
					</h4>	
				
					<div className="select-option m-t-1">
						<div className="btn-group" >
							
							<button
								type="button"
								onClick={e => doctor.children = "Yes"}
								className={`btn sm ${doctor.children === "Yes" || "white"}`}>
								Yes
							</button>
							
							<button
								type="button"
								onClick={e => doctor.children = "No"}
								className={`btn sm ${doctor.children === "No" || "white"}`}>
								No
							</button>

							<button
								type="button"
								onClick={e => doctor.children = "dontsay"}
								className={`btn sm ${doctor.children === "dontsay" || "white"}`}>
								Prefer not to say
							</button>
						
							<button
								type="button"
								onClick={e => doctor.children = "yesbut"}
								className={`btn sm ${doctor.children === "yesbut" || "white"}`}>
								Yes, but only
							</button>
						
						</div>
					</div>

					{doctor.children === "yesbut" && <input
						className={`input`}
						type="text"
						placeholder="Yes, but only..."
						value={doctor.childrenPreference}
						onChange={e => doctor.childrenPreference = e.target.value}
					/>}
					
					<h4>
						Will you see patients who are funded through:
					</h4>	
					
				
					<h5 className={`m-t-1 ${this.error && 'error'} ${this.error && doctor.wc && 'complete'}`}>Worker's Compensation</h5>
					<div className="select-option m-t-1">
						<div className="btn-group" >
							
							<button
								type="button"
								onClick={e => doctor.wc = "Yes"}
								className={`btn sm ${doctor.wc === "Yes" || "white"}`}>
								Yes
							</button>
							
							<button
								type="button"
								onClick={e => doctor.wc = "No"}
								className={`btn sm ${doctor.wc === "No" || "white"}`}>
								No
							</button>

							<button
								type="button"
								onClick={e => doctor.wc = "dontsay"}
								className={`btn sm ${doctor.wc === "dontsay" || "white"}`}>
								Prefer not to say
							</button>
						
						</div>
					</div>

					
					<h5 className={`${this.error && 'error'} ${this.error && doctor.dva && 'complete'}`}>DVA</h5>
					<div className="select-option m-t-1">
						<div className="btn-group" >
							
							<button
								type="button"
								onClick={e => doctor.dva = "Yes"}
								className={`btn sm ${doctor.dva === "Yes" || "white"}`}>
								Yes
							</button>
							
							<button
								type="button"
								onClick={e => doctor.dva = "No"}
								className={`btn sm ${doctor.dva === "No" || "white"}`}>
								No
							</button>

							<button
								type="button"
								onClick={e => doctor.dva = "dontsay"}
								className={`btn sm ${doctor.dva === "dontsay" || "white"}`}>
								Prefer not to say
							</button>
						
						</div>
					</div>


					<h5 className={`${this.error && 'error'} ${this.error && doctor.mvit && 'complete'}`}>MVIT <small>(Motor Vehicles)</small></h5>
					<div className="select-option m-t-1">
						<div className="btn-group" >
							
							<button
								type="button"
								onClick={e => doctor.mvit = "Yes"}
								className={`btn sm ${doctor.mvit === "Yes" || "white"}`}>
								Yes
							</button>
							
							<button
								type="button"
								onClick={e => doctor.mvit = "No"}
								className={`btn sm ${doctor.mvit === "No" || "white"}`}>
								No
							</button>

							<button
								type="button"
								onClick={e => doctor.mvit = "dontsay"}
								className={`btn sm ${doctor.mvit === "dontsay" || "white"}`}>
								Prefer not to say
							</button>
						
						</div>
					</div>
				
				<h4>
					Any patients you do not see?
				</h4>	
				
				{doctor.patientsPreferences && doctor.patientsPreferences.map((thePreference, index) =>
					<div key={index} className="m-b-1">
						<input
							className={`input medium m-r-1`}
							type="email"
							placeholder="e.g. 'No knees' or 'No medicolegal'"
							value={thePreference.title} 
							onChange={e => { thePreference.title = e.target.value; }}
						/>
						<div className="btn base sm" onClick={()=>doctor.patientsPreferences.splice(index,1)}><i className="fa fa-fw fa-times"></i> Remove</div>
					</div>)}
				
				<div>
					<div
						onClick={()=>doctor.patientsPreferences.push({ title: ""})}
						className={`btn sm m-b-1`}><i className="fa fa-fw fa-plus"></i> Add another</div>	
				</div>

				<div className="m-t-1">
					<div
						onClick={this.handlePrev}	
						className={`btn base m-r-1`}><i className="fa fa-fw fa-arrow-left"></i> Previous</div>	
					<div
						onClick={this.handleNext}	
						className={`btn ${!this.completed && 'disabled'}`}><i className="fa fa-fw fa-arrow-right"></i> Next</div>
				</div>
				
			</div>
		);
	}
}

export default GeneralDetails;


// WEBPACK FOOTER //
// ./src/Containers/Listing/5.PatientsDetails.js